import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const API_BASE = `${API_BASE_URL}/api/supply-chain`;

export const supplyChainService = {
  async getFlowData(filters = {}) {
    const params = new URLSearchParams();
    if (filters.period_start) params.append('period_start', filters.period_start);
    if (filters.period_end) params.append('period_end', filters.period_end);
    if (filters.ledger_ids && filters.ledger_ids.length > 0) {
      params.append('ledger_ids', filters.ledger_ids.join(','));
    }
    if (filters.max_ledgers) params.append('max_ledgers', filters.max_ledgers);
    if (filters.show_transfer_receipts !== undefined) {
      params.append('show_transfer_receipts', filters.show_transfer_receipts);
    }
    const query = params.toString();
    const response = await axios.get(`${API_BASE}/flow${query ? `?${query}` : ''}`);
    return response.data;
  },

  async getPeriods() {
    const response = await axios.get(`${API_BASE}/periods`);
    return response.data;
  },

  async getLedgers() {
    const response = await axios.get(`${API_BASE}/ledgers`);
    return response.data;
  }
};

export default supplyChainService;
